<template>
  <div class="risk-release">
    <div class="risk-release-container">
      <div class="title">发布设置</div>
      <div class="risk-release-content">
        <el-steps :active="active" align-center>
          <el-step title="选择部门"></el-step>
          <el-step title="规制设置"></el-step>
        </el-steps>

        <!-- 选择部门 -->
        <div v-if="active == 1" class="step-content">
          <div class="table">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column label="主体负责人" prop="mainDirector"
              width="300"
              >
                <template slot-scope="scope">
                  <div class="mainDirector-content">
                    <div class="mainDirector">
                      {{scope.row.mainDirector}}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="次要负责人" prop="secondaryDirector"
              >
                <template slot-scope="scope">
                  <div class="secondaryDirector-content" @click="selectSecondaryDirector(scope.row)">
                    <div class="secondaryDirector-main" v-if="scope.row.secondaryDirector.length > 0">
                      <div class="secondaryDirector" v-for="(item, index) in scope.row.secondaryDirector" :key="index">
                        {{item.departmentName}}
                      </div>
                    </div>
                    <div v-else>
                      请选择
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100"
              >
                <template slot-scope="scope">
                  <i class="el-icon-delete" @click="remove(scope.row, scope.$index)"></i>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="operation" @click="addDeptment">
            <el-button type="text" class="btn-text-blue">添加</el-button>
          </div>
        </div>

        <!-- 规制设置 -->
        <div v-if="active == 2" class="step2-content">
          <div class="rule-container" v-for="(item, index) in ruleList" :key="index">
            <div class="rule-title">
              阶段{{index+1}}
            </div>
            <div class="rule-row">
              <div class="sub-title">
                <span class="stars">*</span>
                完成时间：
              </div>
              <div class="rule-row-content">
                <el-date-picker
                  v-model="item.date"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"
                  clearable
                >
                </el-date-picker>
              </div>
            </div>
            <div class="rule-row">
              <div class="sub-title no-stars">完成奖励：</div>
              <div class="rule-row-content">
                <el-input-number v-model="item.reward" controls-position="right"></el-input-number>
              </div>
            </div>
            <div class="rule-row">
              <div class="sub-title no-stars">逾期惩罚：</div>
              <div class="rule-row-content">
                <el-input-number v-model="item.punishment" controls-position="right"></el-input-number>
              </div>
            </div>
          </div>
          <div class="add-stage">
            <el-button 
              type="text" 
              icon="el-icon-plus"
              class="btn-text-blue"
              @click="addStage"
            >添加阶段</el-button>
          </div>
        </div>

      </div>
    </div>

    <div class="foot">
      <el-button v-if="active < 2" class="btn-blue" type="primary" @click="next"
        >下一步</el-button
      >
      <el-button
        v-if="active == 2"
        class="btn-border-text-blue"
        type="primary"
        @click="save"
        >发布</el-button
      >
    </div>

    <!-- 选择部门 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="closeDialog"
    >
      <div class="department-content">
        <div class="select-container">
          <div class="department-list">
            <AllTreeCheckout
              :companyList="departmentList"
              :departmentId="departmentId"
              :selectData="selectData"
              :selectDepartment="selectDepartment"
              @selectTreeNodeList="selectDepartmentHeadTreeNodeList"
            />
          </div>
        </div>
        <div class="border"></div>
        <div class="selected-container">
          <p class="label">已选：</p>
          <div class="selected-content">
            <ul class="selected-list">
              <li
                class="selected-item"
                v-for="(value, index) in selectData"
                :key="index"
              >
                <span class="selected-item-name">
                  <img :src="second" class="second">
                  {{ value.departmentName }}
                </span>
                <span class="remove" @click="removeSelectData(index)">移除</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from "@/common/js/config.js";
import { mapChildSecondDisable, mapChildThirdDisable, treeFind} from "@/common/js/utils.js";
import AllTreeCheckout from "@/components/tree/all-tree-checkout.vue";
import Department from "@/models/department.js";
export default {
  components: {
    AllTreeCheckout,
  },

  data() {
    return {
      active: 1,
      tableData: [],
      dialogVisible: false,
      secondDeptmentId: '',
      allDepartmentList: [],
      
      isSearch: true,
      departmentList: [],
      departmentId: 0,
      title: '添加主体负责人',
      selectData: [],
      selectDepartment: false,
      second: require('../../../../assets/tree/second.png'),
      ruleList: [
        {
          data: '',
          reward: '',
          punishment: '',
        }
      ]
    };
  },

  created() {
    config();
    this.initDapartmentList()
  },

  methods: {
    /* 添加部门 */
    addDeptment() {
      if (this.allDepartmentList.length > 0) {
        let arr = mapChildSecondDisable(this.allDepartmentList)
        this.departmentList = arr
        this.$bus.emit('initSecondaryDirector', this.departmentList)
      }
      this.secondDeptmentId = ''
      this.title = '添加主体负责人'
      this.dialogVisible = true
    },

    next() {
      if (this.active == 1) {
        if (this.tableData.length == 0) return this.$message.error('请先选择部门')
        this.active++
      }
    },

    initDapartmentList() {
      let searchDepartment = ''
      let id = ''
      Department.getDepartmentList(id, searchDepartment).then(res => {
        if (res.success) {
          let arr = mapChildSecondDisable(res.result)
          this.allDepartmentList = res.result
          this.departmentList = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    remove(row, index) {
      this.tableData.splice(index,1)
    },

    /* 选择次要负责人 */
    selectSecondaryDirector(row) {
      this.secondDeptmentId = row.secondDeptmentId
      this.selectData = row.secondaryDirector
      let idList = [] 
      row.secondaryDirector.map(i => {
        idList.push(i.id)
      })
      this.title = '添加次要负责人'
      this.dialogVisible = true
      let arr = treeFind(this.allDepartmentList, node => node.id == row.secondDeptmentId)
      this.departmentList = mapChildThirdDisable([arr])
      this.$bus.emit('initSecondaryDirector', this.departmentList)
      this.$bus.emit('allTreeclear', idList)
    },

    selectDepartmentHeadTreeNodeList(v) {
      this.selectData = v
    },

    closeDialog() {
      this.selectData = [],
      this.dialogVisible = false
    },
    
    /* 移除 */
    removeSelectData(index) {
      this.selectData.splice(index, 1);
      this.$bus.emit('allTreeCheckedDel', this.selectData)
    },

    confirm() {
      if (this.title == '添加主体负责人') {
        this.selectData.map(i => {
          let obj = {}
          obj.secondDeptmentId = i.id
          obj.mainDirector = i.departmentName
          obj.secondaryDirector = []
          this.tableData.push(obj)
        })
      } else {
        let arr = []
        this.selectData.map(i => {
          let obj = {}
          obj.id = i.id
          obj.departmentName = i.departmentName
          arr.push(obj)
        })
        this.tableData.map(i => {
          if (i.secondDeptmentId == this.secondDeptmentId) {
            i.secondaryDirector = arr
          }
        })
      }
      this.closeDialog()
    },

    /* 添加阶段 */
    addStage() {
      let obj = {
        data: '',
        reward: '',
        punishment: '',
      }
      this.ruleList.push(obj)
    },

    save() {
      let isFlag = false
      this.ruleList.map(i => {
        if (!i.date) isFlag = true
      })
      if (isFlag) return this.$message.error('请选择完成时间')
      this.$message.success('发布成功')
    }
  },
};
</script>

<style lang='scss'>
.risk-release {
  flex: 1;
  width: 100%;
  background: $bg-white;
  .risk-release-container {
    height: 100%;
    position: relative;
    @include flex-column-center;
  }
  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    padding-left: 20px;
    font-size: $fs-medium-s;
    font-weight: 400;
    color: $color-BlackGrey;
    text-align: left;
    border-bottom: 1px solid $bg-ShallowLightSnow;
    margin-bottom: 40px;
  }
  .risk-release-content {
    width: 100%;
    flex: 1;
    min-height: 703px;
    .step-content {
      padding: 0px 24px;
      margin-top: 30px;
      .operation {
        width: 100%;
        cursor: pointer;
        border-bottom: 1px solid $bg-ShallowLightSnow;
      }
      .el-icon-delete {
        color: $color-PhoneStar;
        cursor: pointer;
      }
      .mainDirector-content {
        min-height: 34px;
        @include flex-start;
        padding-left: 10px;
        border: 1px solid $bg-ShallowLightSnow;
        .mainDirector {
          width: fit-content;
          height: 24px;
          line-height: 24rpx;
          padding: 0px 12px;
          background: $bg-WhiteSmoke;
          border-radius: 12px;
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-grey;
        }
      }
      .secondaryDirector-content {
        min-height: 34px;
        @include flex-start;
        border: 1px solid $bg-ShallowLightSnow;
          padding-left: 10px;
        .secondaryDirector-main {
          width: 100%;
          @include flex-start;
          flex-wrap: wrap;
          .secondaryDirector {
            width: fit-content;
            height: 24px;
            line-height: 24px;
            padding: 0px 12px;
            margin-right: 12px;
            background: $bg-WhiteSmoke;
            border-radius: 12px;
            font-size: $fs-small-l;
            font-weight: 400;
            color: $color-grey;
          }
        }
      }
    }
    .step2-content {
      @include flex-column-center;
      margin-bottom: 130px;
      .rule-container {
        width: 460px;
        .rule-title {
          height: 40px;
          line-height: 40px;
          font-size: $fs-medium-l;
          font-weight: 400;
          color: $color-BlackGrey;
          text-align: left;
          margin-bottom: 30px;
          border-bottom: 1px solid $bg-ShallowLightSnow;
        }
        .stars {
          color: $color-PhoneStar;
        }
        .rule-row {
          @include flex-start;
          margin-bottom: 20px;
          .sub-title {
            font-size: $fs-small-l;
            font-weight: 400;
            color: $color-BlackGrey;
          }
          .no-stars {
            padding-left: 10px;
          }
          .rule-row-content {
            flex: 1;
            .el-date-editor,
            .el-input-number {
              width: 100%;
            }
            .el-input-number .el-input {
              width: 340px;
            }
            .el-input-number .el-input__inner {
              text-align: left;
            }
            .el-input-number__decrease {
              border-top: 1px solid $bg-ShallowLightSnow;
              border-right: 1px solid $bg-ShallowLightSnow;
              border-left: 1px solid $bg-ShallowLightSnow;
            }
            .el-input-number__increase {
              border: 1px solid $bg-ShallowLightSnow;
            }
            .el-input-number.is-controls-right .el-input-number__decrease{
              right: 0px;
              bottom: -2px;
            }
            .el-input-number.is-controls-right .el-input-number__increase {
              right: 0px;
              top: 3px;
            }
            .el-input-number.is-controls-right .el-input-number__decrease, .el-input-number.is-controls-right .el-input-number__increase {
              line-height: 16px;
              height: 16px;
              box-sizing: border-box;
            }
          }
        }
      }
      .add-stage {
        width: 460px;
        @include flex-end;
      }
    }
  }
  
  .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
    height: auto;
    line-height: initial;
  }
  .foot {
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    .el-button {
      padding: 0;
    }
    .export-tmp {
      margin-right: 20px;
    }
  }
  
  .el-dialog__body {
    position: relative;
  }
  .department-content {
    margin: 16px 20px;
    border: 1px solid $bg-ShallowLightSnow;
    display: flex;
    justify-content: space-between;
    overflow-y: auto;
    height: 350px;
    .border {
      position: absolute;
      top: 0px;
      left: 50%;
      height: 350px;
      transform: translateX(-50%);
      width: 1px;
      background: $bg-ShallowLightSnow;
    }
    .select-container {
      width: 50%;
      .department-list {
        padding: 12px;
        box-sizing: border-box;
      }
    }
    .selected-container {
      flex: 1;
      padding: 12px;
      .label {
        text-align: left;
        height: 40px;
        line-height: 40px;
        font-size: $fs-medium-s;
      }
      .selected-content {
        padding: 12px;
        box-sizing: border-box;
        .selected-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: $fs-small-l;
          color: $color-grey;
          .second {
            margin-right: 19px;
          }
          .selected-item-name {
            height: 14px;
            line-height: 14px;
          }
          .remove {
            color: #ed6767;
            cursor: pointer;
          }
        }
      }
    }
  }
  .department-dialog-footer {
    display: flex;
    justify-content: center;
    padding-top: 16px;
  }
}
</style>
